<template>
  <div class="search" :class="{ 'search_size-small': size === 'small' }">
    <input
      v-model.trim="value"
      type="text"
      :placeholder="placeholder"
      @keyup.enter="searchHandle"
    />
    <button type="button" @click.prevent="searchHandle">
      <img src="../../assets/icons/i_search.svg" alt="search" />
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "SearchSidebar",
  props: {
    term: {
      type: String,
      default: null,
    },
    vocabulary: {
      type: String,
      default: "jurisdictions",
    },
    placeholder: {
      type: String,
      default: "Search the site",
    },
    size: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    value: "",
  }),
  computed: {
    ...mapState("Search", ["searchSidebarText"]),
  },
  methods: {
    searchHandle() {
      // Copied from the handle for the main search, with a few small changes
      if (this.value.length && this.value !== this.searchText) {
        if (this.$matomo) {
          this.$matomo.trackEvent("Search", "Search text", this.value);
        }
        if (this.$churnZero) {
          this.$churnZero.trackEvent("Search", "Search text");
        }
        const val = `"${this.value}"`;
        const arrOfValues = [this.value];

        const query = {
          query: val + `&filter[${this.vocabulary}][]=${this.term}`,
        };

        if (this.$route.name === "data") {
          query["type[]"] = "data_forecasts";
        }
        if (this.$route.name !== "search") {
          // const q = { ...query, offset: "0" };  //Doesn't seem to be used so commenting out.
          this.$router.push({
            path: `/search?query="${this.value}"&filter[${this.vocabulary}][]=${this.term}`,
          });
        }

        this.$store.commit("Search/setData", {
          label: "searchMultiple",
          data: arrOfValues,
        });
        this.$store.commit("Search/setData", {
          label: "searchText",
          data: this.value,
        });

        this.value = "";
      } else if (this.$route.name !== "search") {
        this.$router.push({ path: "/search" });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";

.search {
  position: relative;

  @include below($md) {
    width: 100%;
  }

  input {
    width: 100%;
    height: 5rem;
    border: 1px solid $light_blue;
    font-size: 1.8rem;
    padding: 0 5.5rem 0 2.5rem;
    position: relative;
    z-index: 1;

    @include below($md) {
      height: 4rem;
      padding: 0 4.5rem 0 1.5rem;
    }
  }

  button {
    position: absolute;
    z-index: 1;
    right: 0;
    top: 0;
    height: 5rem;
    width: 5rem;
    background: $red;
    display: flex;
    justify-content: center;
    align-items: center;
    border: none;
    transition: opacity 0.3s;

    @include below($md) {
      height: 4rem;
      width: 4rem;
    }

    &:hover {
      opacity: 0.85;
    }
  }

  &_size-small {
    input {
      width: 100%;
      height: 4rem;
      font-size: 1.4rem;
      padding: 0 4.5rem 0 1.5rem;
    }

    button {
      $size: 4rem;

      height: $size;
      width: $size;

      img {
        $size: 1.6rem;

        height: $size;
        width: $size;
      }
    }
  }
}
</style>
